import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import ContextBar from './ContextBar';
import AppAsideNav from "./AppAsideNav";
import MenuObject from '../canvas/menu-object'

export default @connect(reduce, actions)
class AppSubheader extends Component {
  constructor() {
    super();
  }

  render(props, state) {
    return (
      <header id="app-subheader" className="sub">
        <ContextBar/>
      </header>
    )
  }
}
